module.exports = __webpack_public_path__ + "static/media/refresh.27bc6404.svg";